module.exports = __webpack_public_path__ + "img/9.6efc13c3.jpg";